<template>
  <div>
    <a-input
      :value="option"
      placeholder="请输入问题选项"
      style="width: 57%; margin-right: 2%;"
      @change="changeOption"
    />
    <a-radio-group
      :value="answer"
      @change="changeRadio"
    >
      <a-radio :value="1">
        正确
      </a-radio>
      <a-radio :value="0">
        错误
      </a-radio>
    </a-radio-group>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data(){
    const value=this.value||{};
    return {
      option: value.options,
      answer: value.answers,
    };
  },
  watch: {
    value(val){
      this.option=val.options;
      this.answer=val.answers;
    },

  },
  methods: {
    // 问题选项
    changeOption(e){
      this.$emit('change', {options: e.target.value, answers: this.answer});
    },
    // 单选
    changeRadio(e){
      this.$emit('change', {options: this.option, answers: e.target.value});
    },

  },
};
</script>
<style lang="scss" scoped>

</style>